import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';

export interface mitgateState {
  point: string;
}

const MITGATE_KEY = 'React-ts-ant-mitgate';

const localMitgate = LocalStore.getValue<mitgateState>(MITGATE_KEY) || {};

export const defaults: mitgateState = {
  point: '1',
  ...localMitgate
};

const SVIP_MITGATE_KEY = 'React-ts-ant-MITGATE';

export const updateMitgate: (mitgate: mitgateState) => IAction<mitgateState> = (mitgate: mitgateState) => ({
  type: SVIP_MITGATE_KEY,
  payload: mitgate
});

const mitgateReducer: Reducer<mitgateState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case SVIP_MITGATE_KEY:
      LocalStore.setValue(MITGATE_KEY, payload as mitgateState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default mitgateReducer;
